export default "__VITE_ASSET__CwHLmSzG__"